import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic'

export const livemagenta: GetCustomerCopyFunc = () => {
  return {
    scheduleResourceCoordinatorCallLink: 'https://go.oncehub.com/T-MobileResourceCoordination',
  }
}
